import { inject, Injectable, signal } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/naming-convention
import ResizeModule from '@botom/quill-resize-module';
import { TranslateService } from '@ngx-translate/core';
import { CameraService, FileUpload, LoadingService, UploadService } from '@scandium-oy/ngx-scandium';
// eslint-disable-next-line @typescript-eslint/naming-convention
import Quill from 'quill';
import { ReplaySubject } from 'rxjs';

Quill.register('modules/resize', ResizeModule);

@Injectable()
export class QuillService {
  private cameraService = inject(CameraService);
  private loadingService = inject(LoadingService);
  private translate = inject(TranslateService);
  private uploadService = inject(UploadService);

  private index = 0;
  private replaySubjects: ReplaySubject<number>[] = [];
  quillRef: Quill;

  private toolbarOptions = {
    container: [
      [{ size: ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ header: 1 }, { header: 2 }],
      [{ color: [] }, { background: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: [] }],
      ['image'],
    ],
    handlers: {
      // handlers object will be merged with default handlers object
      image: (value) => {
        if (value) {
          const range = this.quillRef.getSelection();
          this.index = range.index;
          this.cameraService.openCamera('note').then((file) => {
            if (file) {
              this.saveImage(file);
            }
          });
        }
      },
    },
    imageResize: true,
  };

  modules = signal({
    resize: {
      locale: {
        altTip: this.translate.instant('editImage.altTip'),
        floatLeft: this.translate.instant('editImage.floatLeft'),
        floatRight: this.translate.instant('editImage.floatRight'),
        center: this.translate.instant('editImage.center'),
        restore: this.translate.instant('editImage.restore'),
      },
    },
    toolbar: this.toolbarOptions,
  });

  private saveImage(imageFile: File) {
    const guid = 'note-' + new Date().toISOString();
    const fileupload = new FileUpload(guid, imageFile);
    this.loadingService.showLoading(5000);
    this.uploadService.uploadImage(fileupload).then((downloadUrl) => {
      this.loadingService.hideLoading();
      const img = '<img class="img-within" src="' + downloadUrl + '"></img>';
      this.quillRef.clipboard.dangerouslyPasteHTML(this.index, img);
    });
  }

  getTextLength() {
    const changed = new ReplaySubject<number>(1);
    if (this.quillRef) {
      this.quillRef.on('text-change', () => {
        const value = this.quillRef.getText().length;
        changed.next(value);
      });
    } else {
      this.replaySubjects.push(changed);
    }
    return changed;
  }

  getHtml() {
    return this.quillRef.getSemanticHTML();
  }

  setRef(ref: Quill) {
    this.quillRef = ref;
    if (this.replaySubjects.length > 0) {
      this.replaySubjects.map((it) => it.next(ref.getText().length));
    }
  }
}
